export const urlRegex = new RegExp('^(http:\\/\\/|https:\\/\\/)');
